import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { StickyModule } from '../../modules/sticky';
import { LoadingModule } from '../loading/loading.module';
import { ValidationChecklistModule } from '../validation-checklist';
import { PendingChangesComponent } from './components/pending-changes/pending-changes.component';
import { ConfirmModalComponent } from '../../dialogs/confirm-modal/confirm-modal.component';
import { SnapshotFormComponent } from './components/snapshot-form/snapshot-form.component';


@NgModule({
    declarations: [
        SnapshotFormComponent,
        PendingChangesComponent,
        ConfirmModalComponent,
    ],
  imports: [
    CommonModule,
    FormsModule,
    LoadingModule,
    ValidationChecklistModule,
    StickyModule,
  ],
    exports: [
        SnapshotFormComponent,
        PendingChangesComponent,
        ConfirmModalComponent,
    ]
})
export class SnapshotModule {
}
